define('entities/mbanas',[
  'app',
  'backbone',
  'settings',
  'jquery',
  'underscore'
], function(
  App,
  Backbone,
  Settings,
  $,
  _
) {
  'use strict';

  var MbAna = Backbone.Model.extend({
    fetch: function() {
      this.url = Settings.url('compuzz', 'v2/mbanas/' + this.get('secId'));

      return Backbone.Model.prototype.fetch.call(this);
    },
    defaults: {
      code: '',
      name: '',
      description: '',
      infectionType: '',
      typeTarget: ''
    },
    idAttribute: 'secId',
    getImageUid:function() {},

    postUrl: function () {
      return Settings.url('compuzz', 'v2/mbanas');
    },

    save: function() {
      this.url = this.postUrl();
      return Backbone.Model.prototype.save.call(this);
    }
  });

  var MbAnaCollection = Backbone.Collection.extend({
    url: function() {
      return Settings.url('compuzz', 'v2/mbanas');
    },
    model: MbAna
  });

  var API = {

    getMbAnaCollectionUrl: function() {
      new MbAnaCollection();
      var params = {};
      return Settings.url('compuzz', 'v2/mbanas', params);
    },

    getAllMbAnas: function(params) {
      var url = Settings.url('compuzz', 'v2/mbanas', params),
          defer = $.Deferred();

      $.ajax({
        method: 'get',
        url: url,
        success: function(items) {
          var list = [];
          _.each(items, function(item){
            list.push(item.secId);
          });
          defer.resolve(list);
        }
      });

      return defer.promise();
    },

    getMbAnaCountUrl: function() {
      var params = '';
      return 'v2/mbanas/rowCount' + params;
    },

    deleteMbAna: function(secId){
      var url = Settings.url('compuzz', 'v2/mbanas/'+secId),
          defer = $.Deferred();

      $.ajax({
        type: 'DELETE',
        url: url,
        success: function (data) {
          defer.resolve(data);
        }
      });

      return defer.promise();
    }
  };

  App.reqres.setHandler('mbana:get-collection-url', function() {
      return API.getMbAnaCollectionUrl();
  });

  App.reqres.setHandler('mbana:get-collection-to-page', function(params) {
      return API.getAllMbAnas(params);
  });

  App.reqres.setHandler('mbana:get-count-url', function() {
    return API.getMbAnaCountUrl();
  });

  App.reqres.setHandler('mbana:model', function(itemJSON) {
    return new MbAna(itemJSON);
  });

  App.reqres.setHandler('mbana:delete', function(secId) {
    return API.deleteMbAna(secId);
  });
});
